<template>
    <v-card flat style="cursor: pointer; border-bottom: 1px solid #EFEFEF">
        <v-card-text :class="`grey--text ${determinarCorTextcard} ma-1 pa-1 text-card-mensagem`">
            <div>
                <div>
                  <div :class="`caption primary--text ${determinarCor} ${determinarFontWeight}`">
                      <span class="text-uppercase">{{mensagem.remetente.nome}}</span>
                      <p class="ma-0"> Dispensa: {{mensagem.processo}} - {{mensagem.loteOuItemDescricao}} </p>
                  </div>
                  <span>{{ mensagem.trechoTexto }}</span>
                </div>
                <div>
                  <div class="justify-right align-right grey--text text--darken-3 mt-1">
                    <v-icon size="15px" :class="`grey--text ${determinarCorTextcard}`">alarm</v-icon>
                    <span style="font-size: 10px" :class="`grey--text ${determinarCorTextcard}`">
                        {{ mensagem.dataHora | az-date(humanizarFormatoDataHora(mensagem.dataHora)) }}
                    </span>
                  </div>
                </div>
            </div>
            <div v-if="!mensagem.lida" class="indicador-nao-lida"></div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'NotificacaoMensagem',
    props: {
        mensagem:{
            type: Object,
            required: true
        }
    },
    computed: {
        determinarFontWeight(){
            return this.mensagem.lida ? '' : 'font-weight-bold'
        },
        determinarCor(){
            return this.mensagem.lida ? 'text--lighten-3' : 'primary--text'
        },
        determinarCorTextcard(){
            return this.mensagem.lida ? 'text--lighten-1' : 'text--darken-2'
        }
    }
}
</script>

<style scoped lang="stylus">
    .indicador-nao-lida
        height 12px
        width 12px
        padding 6px
        margin 0 10px
        border-radius 100%
        --webkit-border-radius: 100%
        background-color var(--v-primary-base)

    .text-card-mensagem
        display flex
        flex-direction row
        justify-content space-between
        align-items center

    .v-card:hover
        cursor pointer
        background-color #ECEFF1
</style>